import React from 'react';
import { CopyButton, Image, LinkIcon, Text } from '@asigna/kit';
import useNetwork from 'hooks/use-network';
import { getAccountExplorerUrl, shortenAddress } from 'utils/helper';

import { checkIcon, disconnectIcon, walletIcon } from '../util/images';

interface CurrentNetworkCardProps {
  icon: string;
  title: string;
  walletAccount: string;
  testnet?: boolean;
  onLogout: () => void;
  handleClose: () => void;
}

export const CurrentNetworkCard: React.FC<CurrentNetworkCardProps> = ({
  icon,
  title,
  walletAccount,
  testnet = false,
  onLogout,
  handleClose,
}) => {
  const [network] = useNetwork();

  return (
    <div className="py-0 px-8 w-full">
      <div className="flex flex-col items-center w-full bg-black-3 rounded-[8px]">
        <div className="flex items-center justify-between w-full py-12 px-16 border-b-[.5px] border-[#34353B]">
          <div className="flex items-center gap-12">
            <div className="relative flex">
              <Image src={icon} size={24} className="" />
              {testnet && (
                <div className="absolute bg-success w-[10px] h-[10px] rounded-[50%] bottom-[-2px] right-[-2px] border-2 border-[#18181A]" />
              )}
            </div>
            <Text message={title} size="m12" />
          </div>
          <Image src={checkIcon} size={16} />
        </div>
        <div className="flex items-center justify-between w-full py-12 px-16 border-b-[.5px] border-[#34353B]">
          <div className="flex items-center gap-8">
            <Image src={walletIcon} size={16} />
            <Text message={shortenAddress(walletAccount)} size="m12" />
          </div>
          <div className="flex items-center gap-8">
            <CopyButton copy={walletAccount || ''} />
            <LinkIcon href={getAccountExplorerUrl(walletAccount, network)} />
          </div>
        </div>
        <button
          className="flex items-center gap-8 w-full py-12 px-16 hover:bg-white-10 rounded-[0px_0px_8px_8px]"
          onClick={onLogout}
        >
          <img src={disconnectIcon} width={16} height={16} alt="Disconnect" />
          <p className="text-m12 text-primary">Disconnect</p>
        </button>
      </div>
    </div>
  );
};
